import { Outlet } from 'react-router-dom'
import { Header } from '@/components/layout/Header'
import { SideNav } from '@/components/layout/SideNav'
import { OfflineBanner } from '@/components/layout/OfflineBanner'
import { BottomNav } from '@/components/layout/BottomNav'
import { MobileOnboarding } from '@/components/layout/MobileOnboarding'
import { TooltipProvider } from '@/components/ui'

/** Sidebar + header + routed content. Mobile collapses the sidebar into a sheet. */
export function AppShell() {
  return (
    <TooltipProvider delayDuration={250}>
      <div className="flex h-full min-h-screen bg-background">
        <SideNav />
        <div className="flex min-w-0 flex-1 flex-col">
          <Header />
          <OfflineBanner />
          {/* pb-20 clears the mobile tab bar; lg drops it. */}
          <main className="flex-1 overflow-y-auto px-3 py-4 pb-28 sm:px-6 sm:py-6 lg:pb-6">
            <div className="mx-auto w-full max-w-[1600px] space-y-5">
              <Outlet />
            </div>
          </main>
        </div>
        <BottomNav />
        <MobileOnboarding />
      </div>
    </TooltipProvider>
  )
}
